import { useReadingTitle } from '@/shared/hooks';
import { Link } from 'react-router-dom';

const NotFoundPrivate = () => {
  const { title } = useReadingTitle();

  return (
    <section
      className="bg-gradient-to-tr from-gray-600 via-gray-200 to-gray-400 flex flex-col items-center justify-center w-full h-full"
      aria-label="Página no encontrada"
    >
      <p
        className="p-4 text-center capitalize text-4xl font-semibold text-primary-pink/80"
        aria-live="polite"
      >
        {title}
      </p>
      <header className="flex flex-col items-center justify-center gap-2 py-8">
        <h1 className="text-6xl font-bold text-gray-600">404</h1>
        <h2 className="text-4xl font-semibold text-gray-500">
          Not Found Content
        </h2>
      </header>

      <div>
        <p className="text-xl text-gray-500 mb-8 text-center max-w-xl font-medium">
          Lo sentimos, los recursos que intenta obtener no estan disponibles por
          el momento, intente más tarde.
        </p>
      </div>

      <footer>
        <Link
          to="/"
          className="text-lg text-gray-500 hover:bg-gray-100 font-medium duration-300 hover:text-gray-800 rounded-xl border-2 border-gray-400 p-2"
        >
          Volver al inicio
        </Link>
      </footer>
    </section>
  );
};

export default NotFoundPrivate;
